import { isRouteErrorResponse } from "react-router";

export type RouteErrorKind = "notFound" | "serviceUnavailable" | "unexpected";

/**
 * Classifies what a route ErrorBoundary / meta function received. Only the
 * statuses the loaders raise on purpose get a name: 404 for a resource that
 * does not exist; 429 (core-api's throttle, passed through) and 503 for an
 * upstream that could not answer right now.
 */
export const getRouteErrorKind = (error: unknown): RouteErrorKind => {
  if (!isRouteErrorResponse(error)) {
    return "unexpected";
  }

  if (error.status === 404) {
    return "notFound";
  }

  if (error.status === 429 || error.status === 503) {
    return "serviceUnavailable";
  }

  return "unexpected";
};

/** A 404, 429 or 503 is an expected outcome the server already logged, not a bug. */
export const shouldReportRouteError = (error: unknown): boolean =>
  getRouteErrorKind(error) === "unexpected";
